var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("is-automatic") },
                model: {
                  value: _vm.state.doc.IsAutomatic,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "IsAutomatic", $$v)
                  },
                  expression: "state.doc.IsAutomatic",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-checkbox", {
                attrs: { value: _vm.hasEndDate, label: _vm.$ct("limit") },
                on: {
                  input: function ($event) {
                    return _vm.toggleEndDate($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-date-picker", {
                attrs: {
                  value: _vm.state.doc.StartDate,
                  fancy: "",
                  label: _vm.$ct("start-date"),
                },
                on: {
                  input: function ($event) {
                    return _vm.state.doc.setStartDate($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c(
                "w-row",
                [
                  _c("w-date-picker", {
                    style: { flexGrow: 1 },
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("end-date"),
                      disabled: !_vm.hasEndDate,
                    },
                    model: {
                      value: _vm.state.doc.EndDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.state.doc, "EndDate", $$v)
                      },
                      expression: "state.doc.EndDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input-number", {
                attrs: {
                  decimals: 0,
                  "calculated-decimals": 0,
                  fancy: "",
                  label: _vm.$ct(_vm.intervalLabel),
                },
                model: {
                  value: _vm.state.doc.Interval,
                  callback: function ($$v) {
                    _vm.$set(_vm.state.doc, "Interval", $$v)
                  },
                  expression: "state.doc.Interval",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-sale-type-select", {
                attrs: {
                  value: _vm.state.doc.SaleTypeID,
                  "ignored-type-ids": [10],
                  "use-id": "",
                  "contact-group-id": 1,
                  label: _vm.$ct("document-type"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setSaleType($event)
                  },
                },
              }),
            ],
            1
          ),
          _vm.isWeekly
            ? _c("app-settings-weekly", { attrs: { value: _vm.state.doc } })
            : _vm.isMonthly
            ? _c("app-settings-monthly", { attrs: { value: _vm.state.doc } })
            : _vm.isMonthlyPerWeek
            ? _c("app-settings-monthly-per-week", {
                attrs: { value: _vm.state.doc },
              })
            : _vm.isYearly
            ? _c("app-settings-yearly", { attrs: { value: _vm.state.doc } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }